import { render, staticRenderFns } from "./DebiteursTab.vue?vue&type=template&id=dfd8c144&scoped=true&"
import script from "./DebiteursTab.vue?vue&type=script&lang=js&"
export * from "./DebiteursTab.vue?vue&type=script&lang=js&"
import style0 from "./DebiteursTab.vue?vue&type=style&index=0&id=dfd8c144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8c144",
  null
  
)

export default component.exports